import { ModalOperations } from '@/model/common';
import { useDisclosure } from '@mantine/hooks';
import { useCallback } from 'react';

export interface UseTableDisclosureProps {
    setDrawerMode?: (mode: ModalOperations) => void;
    setSelectedRow?: (selectedRow: any) => void;
}

export interface UseTableDisclosureReturn {
    viewDisclosure: ReturnType<typeof useDisclosure>;
    bulkDisclosure: ReturnType<typeof useDisclosure>;
    filterDisclosure: ReturnType<typeof useDisclosure>;
    operationDisclosure: ReturnType<typeof useDisclosure>;
    onViewDrawer: (selectedRow?: any) => void;
    onOperationDrawer: (mode: ModalOperations, selectedRow?: any) => void;
}

export const useTableDisclosure = (props: UseTableDisclosureProps): UseTableDisclosureReturn => {
    const { setSelectedRow, setDrawerMode } = props;

    const viewDisclosure = useDisclosure(false);
    const bulkDisclosure = useDisclosure(false);
    const filterDisclosure = useDisclosure(false);
    const operationDisclosure = useDisclosure(false);

    const onViewDrawer = useCallback((selectedRow?: any) => {
        setSelectedRow?.(selectedRow);
        viewDisclosure[1].open();
    }, []);

    const onOperationDrawer = useCallback((mode: ModalOperations, selectedRow?: any) => {
        setDrawerMode?.(mode);
        setSelectedRow?.(selectedRow);
        operationDisclosure[1].open();
    }, []);

    return { filterDisclosure, viewDisclosure, bulkDisclosure, operationDisclosure, onViewDrawer, onOperationDrawer };
};
